import React from 'react';

/**
 * @author: Alisa Münsterberg
 * @date: 2022-10-14
 */

export class CheckIfFinishedButton extends React.Component{
    render(){
        return(
            <button className="App-button" onClick={this.props.onClick} style={{textDecoration : 'none'}}>
                Die Liste ist fertig sortiert!
            </button>
        )};
}